import {
  EnergyProductPair,
  postEnecoBeXapiSiteApiV1PriceSimulationByPriceSimulationIdSimulate,
} from '@eneco/dc-be/client';
import usePublicDCBE from '@eneco/dc-be/hooks/usePublicDCBE';
import unwrapData from '@eneco/dc-be/utils/unwrapData';
import { ProductProposal } from '@sitecore/types/manual/be/ProductList';

import { getSitecorePosition } from '../../../utils/getSitecoreProduct';

interface UsePriceSimulationSimulateParams {
  priceSimulationId: string;
  variableProducts: EnergyProductPair[];
  fixedProducts: EnergyProductPair[];
  dynamicProducts: EnergyProductPair[];
  enecoProductsList: ProductProposal[];
}

export const usePriceSimulationSimulate = ({
  priceSimulationId,
  variableProducts,
  fixedProducts,
  dynamicProducts,
  enecoProductsList,
}: UsePriceSimulationSimulateParams) => {
  const cacheKey = `/price-simulation/${priceSimulationId}/simulate`;
  const shouldFetch = variableProducts.length > 0 || fixedProducts.length > 0 || dynamicProducts.length > 0;

  const {
    data: priceSimulationData,
    isLoading,
    isValidating,
    error,
  } = usePublicDCBE(
    postEnecoBeXapiSiteApiV1PriceSimulationByPriceSimulationIdSimulate,
    {
      body: {
        variableProducts,
        fixedProducts,
        dynamicProducts,
      },
      path: {
        priceSimulationId,
      },
    },
    [cacheKey],
    shouldFetch,
  );

  if (!shouldFetch) return { data: undefined, isLoading: false, isValidating: false, cacheKey, error: undefined };

  const data = unwrapData(priceSimulationData);
  data?.productCombinationOptions.forEach(option => {
    option.sortOrder = getSitecorePosition({
      technicalProductName: option.electricityProduct?.productName ?? option.gasProduct?.productName ?? '',
      enecoProductsList: enecoProductsList,
    });
  });

  return { data, isLoading, isValidating, cacheKey, error };
};
